import React from 'react'
import Appointment from '../../Components/Doctor/Appointment/Appointment'

const DoctorAppointmentPage = () => {
  return (
    <div className='p-5 overflow-hidden'>
      <Appointment />
    </div>
  )
}

export default DoctorAppointmentPage
